// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"b9a27085","270":"8e0e6b21","319":"1f7f6bcf","404":"2022a26e","407":"946e709a","459":"8d10609a","499":"a496ebf3","581":"2701234b","652":"dd7ab553","960":"d3c4ae1a"}[chunkId] + ".chunk.js";
};